/**
 * CRA-safe service worker registration.
 *
 * Important:
 * - Registers only in production.
 * - Avoids throwing if SW isn't supported or if the path 404s (e.g. some preview environments).
 */

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .catch((_err) => {
        // Intentionally ignore: SW registration is an enhancement, not a hard dependency.
      });
  });
}

